export default {
  features: {
    clientSendToReview: {
      button: 'Отправить на рассмотрение',
    },
  },
};
